<mat-card>
    <mat-card-content>
        <div>
            <div *ngIf="dataSource.data && dataSource.data.length==0" class="no-records">
                {{'general.noResults' | translate}}
            </div>
            <mat-tree *ngIf="dataSource.data.length > 0" [dataSource]="dataSource" [treeControl]="treeControl">
                <!-- This is the tree node template for leaf nodes  -->
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
                    <button mat-icon-button [disabled]="true">
                        <mat-icon class="mat-icon-rtl-mirror">
                            {{'chevron_right'}}</mat-icon>
                    </button>
                    <mat-checkbox *ngIf="cb" class="checklist-leaf-node" [checked]="checklistSelection.isSelected(node)"
                        (change)="todoLeafItemSelectionToggle(node)" [disabled]="disabledCheckbox || isDisabled(node)">
                        {{node.name}}
                    </mat-checkbox>
                    <div *ngIf="!cb" [ngStyle]="(node.statusId == statusSvojstvaEnum.Deaktivirano || node.statusNaTipuId == statusSvojstvaEnum.Deaktivirano
                        || node.statusId == statusElementaPorukeEnum.Deaktivirano || node.statusNaPojmuId == statusSvojstvaEnum.Deaktivirano) 
                        && {'text-decoration' : 'line-through'}">
                        <span [ngClass]="{'highlight': node.highlighted}">{{node.name}}</span>
                    </div>
                    <div style="margin-left: 10px;" *ngFor="let button of dugmiciZaAkcije">
                        <button *ngIf="!button.hidden(node)" matTooltip="{{button.tooltip | translate}}" mat-icon-button
                            mat-sm-button [color]="button.color" class="mr-1"
                            (click)="extraBtnClick(node, button.btnAction)">
                            <mat-icon>{{button.icon}}</mat-icon>
                        </button>
                    </div>
                </mat-tree-node>
                <!-- This is the tree node template for expandable nodes  -->
                <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
                    <button type="button" mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                        <mat-icon class="mat-icon-rtl-mirror">
                            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                        </mat-icon>
                    </button>
                    <div [ngStyle]="(node.statusId == statusSvojstvaEnum.Deaktivirano || node.statusNaTipuId == statusSvojstvaEnum.Deaktivirano
                        || node.statusId == statusElementaPorukeEnum.Deaktivirano || node.statusNaPojmuId == statusSvojstvaEnum.Deaktivirano) 
                        && {'text-decoration' : 'line-through'}">
                        <span [ngClass]="{'highlight': node.highlighted}">{{node.name}}</span>
                    </div>
                    <div style="margin-left: 10px;" *ngFor="let button of dugmiciZaAkcije">
                        <button *ngIf="!button.hidden(node)" matTooltip="{{button.tooltip | translate}}" mat-icon-button
                            mat-sm-button [color]="button.color" class="mr-1"
                            (click)="extraBtnClick(node, button.btnAction)">
                            <mat-icon>{{button.icon}}</mat-icon>
                        </button>
                    </div>
                </mat-tree-node>
            </mat-tree>
        </div>
    </mat-card-content>
</mat-card>